"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewReportDetails", {
    enumerable: true,
    get: function() {
        return ReviewReportDetails;
    }
});
const _bson = require("bson");
const _zod = /*#__PURE__*/ _interop_require_default(require("zod"));
const _models = require("@performyard/models");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const GoalAnswerName = _zod.default.object({
    goal_name: _zod.default.string()
});
const Answer = _zod.default.union([
    _zod.default.string(),
    _zod.default.number(),
    _zod.default.string().array(),
    GoalAnswerName.merge(_models.GoalDiscussionAnswerModel.pick({
        goal_id: true,
        message: true,
        scale_value: true,
        score: true,
        weight: true
    })).array(),
    GoalAnswerName.merge(_models.GoalDiscussionAnswerModel.pick({
        goal_id: true
    })).array()
]);
const ReviewReportDetails = _zod.default.object({
    authors_names: _zod.default.string().array(),
    signers_names: _zod.default.string().array(),
    subject_name: _zod.default.string(),
    subject_group_name: _zod.default.string().nullable(),
    questions_with_answers: _zod.default.object({
        id: _zod.default.instanceof(_bson.ObjectId),
        question: _zod.default.string(),
        type: _models.ReviewQuestionTypeModel,
        answer: Answer,
        choices: _models.ReviewQuestionModel.shape.choices
    }).array(),
    form_name: _zod.default.string(),
    authors_due_date: _models.ReviewReportModel.shape.authors_due_date,
    signers_due_date: _models.ReviewReportModel.shape.signers_due_date,
    complete_date: _models.ReviewReportModel.shape.complete_date,
    total_author_steps: _zod.default.number(),
    completed_author_steps: _zod.default.number(),
    total_signer_steps: _zod.default.number(),
    completed_signer_steps: _zod.default.number(),
    total_steps: _zod.default.number(),
    completed_steps: _zod.default.number(),
    redacted: _models.ReviewReportModel.shape.redacted,
    external: _models.ReviewReportModel.shape.external,
    external_author: _models.ReviewReportModel.shape.external_author
});
